// extracted by mini-css-extract-plugin
module.exports = {"note":"styles_note__kTTzq"};